import { render, staticRenderFns } from "./QuestionBankGame.vue?vue&type=template&id=24bcdfd4&scoped=true&"
import script from "./QuestionBankGame.vue?vue&type=script&lang=js&"
export * from "./QuestionBankGame.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankGame.vue?vue&type=style&index=0&id=24bcdfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bcdfd4",
  null
  
)

export default component.exports